import { HttpErrorResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import {
  MatSnackBar,
} from '@angular/material/snack-bar';
import { BackendErrorData } from '../models/common.model';

@Injectable({
  providedIn: 'root'
})
export class SnackBarService {

  private SNACK_BAR_DURATION_MS = 7000;
  private SNACK_BAR_BUTTON_TEXT = 'OK';

  private _snackBar = inject(MatSnackBar);

  openSuccessSnackBar(message: string) {
    this._snackBar.open(message, this.SNACK_BAR_BUTTON_TEXT, {
      horizontalPosition: "center",
      verticalPosition: "top",
      duration: this.SNACK_BAR_DURATION_MS,
      panelClass: ['green-snackbar',]
    });
  }

  openErrorSnackBar(message: string) {
    this._snackBar.open(message, this.SNACK_BAR_BUTTON_TEXT, {
      horizontalPosition: "center",
      verticalPosition: "top",
      duration: this.SNACK_BAR_DURATION_MS,
      panelClass: ['red-snackbar',]
    });
  }

  openErrorSnackBarFromHttpError(httpErrorResponse: HttpErrorResponse, headerErrorMessage: string) {
    const ERROR_MESSAGE = this.generateErrorMessageForSnackMenu(httpErrorResponse, headerErrorMessage);

    this._snackBar.open(ERROR_MESSAGE, this.SNACK_BAR_BUTTON_TEXT, {
      horizontalPosition: "center",
      verticalPosition: "top",
      duration: this.SNACK_BAR_DURATION_MS,
      panelClass: ['red-snackbar',]
    });
  }

  generateErrorMessageForSnackMenu(httpErrorResponse: HttpErrorResponse, headerErrorMessage: string): string {
    let snackBarErrorMessage = `${headerErrorMessage}:`;
    snackBarErrorMessage += `\n ${httpErrorResponse.message}`;
    const backendErrorData: BackendErrorData | null = httpErrorResponse.error as BackendErrorData;
    if (backendErrorData?.message) {
      snackBarErrorMessage += `\n ${backendErrorData?.message}`;
    }
    if (backendErrorData?.error) {
      snackBarErrorMessage += `\n ${backendErrorData?.error}`;
    }
    if (backendErrorData?.details?.issues.length) {
      snackBarErrorMessage += `\n ${backendErrorData?.details?.issues.join('\n')}`;
    }
    return snackBarErrorMessage
  }
}